import { render, staticRenderFns } from "./DropDownWorkers.vue?vue&type=template&id=70e804f9&scoped=true"
import script from "./DropDownWorkers.vue?vue&type=script&lang=js"
export * from "./DropDownWorkers.vue?vue&type=script&lang=js"
import style0 from "./DropDownWorkers.vue?vue&type=style&index=0&id=70e804f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e804f9",
  null
  
)

export default component.exports